// extracted by mini-css-extract-plugin
export default {"tooltip":"hQ-z","arrow":"iQ-z"};